import ReactDOM from 'react-dom/client';
import store from './store/store';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.min.css'
import { THEME_CONFIG } from './configs/AppConfig';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import * as serviceWorker from './serviceWorker'

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <Provider store={store}>
    <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
      <App />
    </ThemeSwitcherProvider>
  </Provider>
);

serviceWorker.unregister()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
